import { X, CheckCircle2, XCircle } from 'lucide-react';
import BulkRespondModal from '../../modals/BulkRespondModal';
import type { AppealBulkRespond } from './useAppealBulkRespond';

interface AppealBulkBarProps {
  bulk: AppealBulkRespond;
  /** Called after a successful bulk response so the parent can refetch. */
  onDone: () => void;
}

/**
 * Sticky action bar + confirm modal for the customer bulk (multi-select)
 * appeal-response feature. Rendered above the Submitted Appeals table when one
 * or more eligible appeals are selected. Accept is green, Reject is red — the
 * modal collects an optional shared response note and calls the bulk endpoint.
 */
export default function AppealBulkBar({ bulk, onDone }: AppealBulkBarProps) {
  const { selectedAppeals, bulkAction, setBulkAction, clear } = bulk;
  const count = selectedAppeals.length;

  return (
    <>
      {count > 0 && (
        <div className="mx-4 mb-2 flex items-center justify-between gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2">
          <span className="text-sm font-medium text-blue-800">{count} selected</span>
          <div className="flex items-center gap-2">
            <button
              onClick={clear}
              className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg border bg-white text-gray-600 hover:bg-muted transition-colors"
            >
              <X className="h-4 w-4" />
              Clear
            </button>
            <button
              onClick={() => setBulkAction('reject')}
              className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg bg-red-600 hover:bg-red-700 text-white transition-colors"
            >
              <XCircle className="h-4 w-4" />
              Reject Selected ({count})
            </button>
            <button
              onClick={() => setBulkAction('accept')}
              className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg bg-green-600 hover:bg-green-700 text-white transition-colors"
            >
              <CheckCircle2 className="h-4 w-4" />
              Accept Selected ({count})
            </button>
          </div>
        </div>
      )}

      {bulkAction && count > 0 && (
        <BulkRespondModal
          isOpen={true}
          action={bulkAction}
          appeals={selectedAppeals}
          onClose={() => setBulkAction(null)}
          onSuccess={onDone}
        />
      )}
    </>
  );
}
